/**
 * @file Business rules for ordering.
 */

// ==== ValueObjects from Backend ==== //

/**
 * Product is a value object coming from the backend.
 */
class Product {
    constructor(id, name, category, price, supplement_group) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.category = category;
        this.supplement_group = supplement_group;
    }
}

class Supplement {
    constructor(id, name, price, group) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.group = group;
    }
}

// ==== Business classes ==== //

class SupplementOrder {
    constructor(s) {
        this.supplement = s;
        this.quantity = 0;
        this.group = s.group;
    }

    increment() {
        this.quantity++;
    }

    decrement() {
        if (this.quantity > 0) {
            this.quantity--;
        }
    }

    getPrice() {
        let result = this.quantity * this.supplement.price;
        return result;
    }

    getShortDescription() {
        if (this.quantity < 1) return '';

        return this.supplement.name + '(' + String(this.quantity) + ') € ' + String(this.quantity * this.supplement.price);
    }
}

class SupplementOrders extends Array {
    getSupplementOrder(s) {
        let o = this.find((v,i,o) => {return v.supplement.id === s.id});
        return o;
    }

    increment(s) {
        let o = this.getSupplementOrder(s);
        if (!o) {
            o = new SupplementOrder(s)
            this.push(o);
        }
        o.increment();
    }

    decrement(s) {
        let o = this.getSupplementOrder(s);
        if (o) {
            o.decrement();
            if (o.quantity < 1) {
                this.splice(this.indexOf(o), 1);
            }
        }
    }

    getPrice() {
        let result = 0.0;
        this.forEach(v => result += v.getPrice());
        return result;
    }

    getShortDescription() {
        let result = '';
        this.forEach((v,i,a) => {
            result += ' ' + v.getShortDescription();// + ' (' + String(v.quantity) + ') € ' + String(v.quantity * v.supplement.price);
        });
        return result.trim();
    }

    /**
     * Get list of supplements used.
     *
     * @returns [] of supplements.
     */
    getSupplements() {
        let result = [];
        this.forEach(v => result.push[v.supplement]);
        return result;
    }
}

class ProductOrder {
    constructor(product) {
        this.id = product.id;
        this.product = product;
        this.quantity = 0;
        this.supplements = new SupplementOrders();
        this.supplement_group = product.supplement_group;
    }

    empty() {
        this.quantity = 0;
        this.supplements = new SupplementOrders();
    }

    hasSupplements() {
        return !(this.product.supplement_group == -1 || this.product.supplement_group === 99);
    }

    increment() {
        this.quantity++;
    }

    decrement() {
        if (this.quantity > 0) {
            this.quantity--;
        }
    }

    isValidSupplement(supplement) {
        if (this.hasSupplements()) {
            if (supplement.group == this.supplement_group) {
                return true;
            }
            console.log("Cannot add supplement from wrong group", supplement.group, 'to group', this.product.supplement_group);
            return false;
        }
        console.log("No supplements allowed");
        return false;
    }
    supplementIncrement(supplement) {
        if (!this.isValidSupplement(supplement)) return;
        this.supplements.increment(supplement);
    }

    supplementDecrement(supplement) {
        if (!this.isValidSupplement(supplement)) return;
        this.supplements.decrement(supplement);
    }

    getPrice() {
        let result = 0.0;
        result += this.supplements.getPrice();
        result += this.product.price;
        result *= this.quantity;
        return result;
    }

    getShortDescription() {
        let result = this.product.name + ' (' + String(this.quantity) + ') € ' + String(this.quantity * this.product.price);
        if (this.supplements.length > 0) {
            result += ' ' + this.supplements.getShortDescription().trim();
        }
        return result;
    }

    getSupplements() {
        return this.supplements.getSupplements();
    }
}

class ProductOrders extends Array {
    constructor(product) {
        super();
        this.product = product;
        this.category = product.category;
        this.supplement_group = product.supplement_group;

        this.addProductOrder();
    }

    isBillable() {
        let result = false;
        this.forEach((v,i,a) => result ||= v.quantity > 0);
        return result;
    }

    getPrice() {
        let result = 0.0;
        this.forEach((v,i,a) => (result += v.getPrice()));
        return result;
    }

    addProductOrder() {
        let po = new ProductOrder(this.product);
        this.push(po);
    }

    hasSupplements() {
        return this[0].hasSupplements()
    }

    /**
     * Deletes all empty productOrder
     */
    cleanup() {
        for(let i = this.length-1; i >= 0; i--){
            if (this[i].quantity == 0) {
                console.log('Splicing @ ', i);
                // Make sure to keep the last as that is business rule.
                if (this.length > 1) {
                    this.splice(i, 1);
                }
            }
        }
    }

    /**
     * Adds 1 to quantity of first ProductOrder or adds new ProductOrder.
     */
    increment() {
        if (this.hasSupplements()) {
            if (this[this.length - 1].quantity > 0) {
                this.addProductOrder();
            }
            this[this.length - 1].increment();
        }
        else {
            this[0].increment();
        }
    }

    getShortDescription() {
        let result = [];
        this.forEach((v, i, a) => result.push(v.getShortDescription()));
        return result.join('\n');
    }

}

export default { ProductOrders};